export enum Gender {
  Male = 1,
  Female = 2,
  Any = Female | Male, // 0x00000003
  Unknown = 4
}
